var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _circle, _circle2, _circle3, _path8, _g3, _rect2, _path9, _path10, _path11, _path12, _path13, _path14, _g4, _path15, _path16, _path17, _path18, _path19, _path20, _g5, _path21, _g6, _g7, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 171,
    viewBox: "0 0 324 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_96116)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "url(#paint0_linear_374_96116)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.194 23.5383C386.615 51.7683 373.736 94.5986 337.753 120.628C301.868 146.587 258.296 144.264 237.819 115.957C217.236 87.5034 227.223 41.9449 262.929 16.1151C298.637 -9.7156 345.611 -4.91448 366.194 23.5383Z",
    stroke: "url(#paint1_linear_374_96116)",
    strokeWidth: 6.46129
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.2 8.87626C389.995 44.1854 382.299 86.8792 340.851 120.517C298.174 151.985 251.879 144.394 227.546 113.444C203.213 82.4934 212.137 31.0455 249.927 3.70892C287.716 -23.6277 337.782 -22.1135 360.2 8.87626Z",
    fill: "url(#paint2_linear_374_96116)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.843 8.05579C366.08 22.2062 367.773 40.0091 362.241 57.7807C356.7 75.576 343.934 93.1871 325.555 106.482C288.59 133.222 244.247 131.37 223.811 103.12C203.271 74.7264 213.96 28.5691 250.745 1.95905C287.531 -24.6519 335.304 -20.337 355.843 8.05579Z",
    stroke: "url(#paint3_linear_374_96116)",
    strokeWidth: 6.46129
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.59 8.10005C364.519 31.5027 355.012 71.7831 319.573 97.4199C284.133 123.057 242.9 119.481 225.971 96.0783C209.042 72.6756 218.549 32.3953 253.989 6.75843C289.428 -18.8784 330.661 -15.3026 347.59 8.10005Z",
    fill: "#F6D971",
    stroke: "url(#paint4_linear_374_96116)",
    strokeWidth: 17.948
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.107 88.4702L254.601 61.2299L317.655 69.0684L291.107 88.4702Z",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.925714
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.197 60.7696L301.212 34.6L290.531 87.4742L254.197 60.7696Z",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.925714
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_374_96116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    stroke: "#F6D971",
    strokeWidth: 0.925714
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_374_96116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.257 84.1709C273.272 73.7245 269.453 61.0866 272.321 50.4965C282.341 55.8125 287.675 78.3943 285.257 84.1709Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.257 84.1709C273.272 73.7245 269.453 61.0866 272.321 50.4965C282.341 55.8125 287.675 78.3943 285.257 84.1709Z",
    stroke: "#F6D971",
    strokeWidth: 0.925714
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M253.341 60.7148L284.724 83.7799L263.932 29.585L253.341 60.7148Z",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.925714
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 301.403,
    cy: 33.7749,
    r: 4.05936,
    transform: "rotate(36.3143 301.403 33.7749)",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.462857
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.193,
    cy: 69.1391,
    r: 3.39924,
    transform: "rotate(36.3143 317.193 69.1391)",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.462857
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.15,
    cy: 30.155,
    r: 3.39924,
    transform: "rotate(-8.68571 264.15 30.155)",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.462857
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M338.91 14.4083C346.197 24.4827 347.156 37.85 342.578 51.456C338.001 65.0586 327.915 78.7753 313.354 89.3093C298.792 99.8433 282.608 105.13 268.256 105.22C253.901 105.31 241.505 100.216 234.217 90.1421C226.929 80.0677 225.97 66.7003 230.549 53.0944C235.126 39.4917 245.211 25.775 259.773 15.241C274.335 4.70705 290.519 -0.579367 304.871 -0.66974C319.226 -0.760135 331.622 4.33388 338.91 14.4083Z",
    stroke: "url(#paint5_linear_374_96116)",
    strokeWidth: 2.87168
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_374_96116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.786 47.728L378.34 64.547C381.61 45.3291 374.46 29.9472 371.65 25.68C369.426 21.5115 365.3 15.656 360.441 9.23124C347.545 -10.9302 320.361 -28.912 278.102 -15.4846C227.842 1.80048 211.183 42.5319 209.396 60.5175L363.49 45.7588L367.786 47.728Z",
    fill: "#FEFFFE",
    fillOpacity: 0.22
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dddddd_374_96116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_374_96116)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5146,
    y: 47.8232,
    width: 23.1429,
    height: 23.1429,
    rx: 11.5714,
    fill: "#1B1A1A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dddddd_374_96116)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "url(#paint6_linear_374_96116)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7939 58.7772L29.7776 52.8262L31.7613 58.7772H27.7939Z",
    fill: "url(#paint7_linear_374_96116)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7773 52.8262L31.761 58.7772H34.4059L29.7773 52.8262Z",
    fill: "url(#paint8_linear_374_96116)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7284L25.1484 58.7773H27.7933L29.777 64.7284Z",
    fill: "url(#paint9_linear_374_96116)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7613 58.7773H27.7939L29.7776 64.7284L31.7613 58.7773Z",
    fill: "url(#paint10_linear_374_96116)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.761 58.7773H34.4059L29.7773 64.7284L31.761 58.7773Z",
    fill: "url(#paint11_linear_374_96116)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_374_96116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.777 52.8262L31.7607 58.7772H34.4056L29.777 52.8262Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 58.7772L29.777 52.8262L31.7607 58.7772H27.7933Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7282L25.1484 58.7772H27.7933L29.777 64.7282Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H34.4056L29.777 64.7282L31.7607 58.7772Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H27.7933L29.777 64.7282L31.7607 58.7772Z",
    fill: "white",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_374_96116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_374_96116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 52,
    width: 10,
    height: 13
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "url(#paint12_linear_374_96116)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 52.8262L31.7607 58.7772H34.4056L29.777 52.8262Z",
    fill: "url(#paint13_linear_374_96116)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 58.7772L29.777 52.8262L31.7607 58.7772H27.7933Z",
    fill: "url(#paint14_linear_374_96116)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7282L25.1484 58.7772H27.7933L29.777 64.7282Z",
    fill: "url(#paint15_linear_374_96116)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H34.4056L29.777 64.7282L31.7607 58.7772Z",
    fill: "url(#paint16_linear_374_96116)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H27.7933L29.777 64.7282L31.7607 58.7772Z",
    fill: "url(#paint17_linear_374_96116)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_374_96116)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_374_96116)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7909 52.8306L27.8072 58.7816L27.7793 58.7723L29.763 52.8213L29.7909 52.8306Z",
    fill: "url(#paint18_linear_374_96116)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7627 64.7235L31.7464 58.7725L31.7742 58.7818L29.7906 64.7328L29.7627 64.7235Z",
    fill: "url(#paint19_linear_374_96116)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_374_96116)",
    filter: "url(#filter7_f_374_96116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_374_96116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 52,
    width: 5,
    height: 7
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7483 52.8262L27.7646 58.7258H31.7834L29.7483 52.8262Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.0146939
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_374_96116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.1953,
    y: 33.9453,
    width: 0.861728,
    height: 46.9824,
    transform: "rotate(30.433 42.1953 33.9453)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8672,
    y: 35.8389,
    width: 1.27325,
    height: 45.5408,
    transform: "rotate(30.433 42.8672 35.8389)",
    fill: "white",
    fillOpacity: 0.2
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_374_96116)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.7769,
    cy: 53.273,
    rx: 0.330612,
    ry: 0.446843,
    fill: "url(#paint20_linear_374_96116)"
  })))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5968 66.0778C56.7415 66.0778 55.9361 65.9223 55.1807 65.6113C54.4365 65.3002 53.7866 64.8725 53.2312 64.3282C52.6757 63.7728 52.237 63.1285 51.9148 62.3953C51.6038 61.6511 51.4483 60.8512 51.4483 59.9959C51.4483 59.1405 51.6093 58.3463 51.9315 57.6131C52.2536 56.8799 52.698 56.2412 53.2645 55.6969C53.8421 55.1414 54.5142 54.7138 55.2807 54.4138C56.0472 54.1028 56.8692 53.9473 57.7468 53.9473C58.7577 53.9473 59.6741 54.1306 60.4962 54.4971C61.3293 54.8637 62.0181 55.3692 62.5624 56.0135L60.7795 57.7964C60.4018 57.3076 59.9574 56.941 59.4464 56.6966C58.9354 56.4522 58.3578 56.3301 57.7135 56.3301C57.0248 56.3301 56.4082 56.4856 55.8639 56.7966C55.3196 57.0965 54.8919 57.5242 54.5809 58.0797C54.2809 58.624 54.131 59.2627 54.131 59.9959C54.131 60.729 54.2809 61.3733 54.5809 61.9288C54.8808 62.4842 55.2918 62.9174 55.8139 63.2285C56.336 63.5395 56.9359 63.695 57.6135 63.695C58.3022 63.695 58.8854 63.5673 59.3631 63.3118C59.8519 63.0452 60.224 62.6675 60.4795 62.1787C60.7461 61.6788 60.8794 61.0734 60.8794 60.3625L62.6124 61.5289L57.3636 61.4455V59.2294H63.5455V59.6126C63.5455 61.0234 63.29 62.212 62.779 63.1785C62.2791 64.1338 61.5793 64.8559 60.6795 65.3447C59.7908 65.8334 58.7632 66.0778 57.5968 66.0778ZM68.7969 66.0778C67.9637 66.0778 67.2084 65.8945 66.5307 65.5279C65.8642 65.1503 65.3366 64.6393 64.9478 63.995C64.559 63.3507 64.3646 62.6286 64.3646 61.8288C64.3646 61.029 64.559 60.3125 64.9478 59.6793C65.3366 59.0461 65.8642 58.5462 66.5307 58.1796C67.1973 57.8019 67.9526 57.6131 68.7969 57.6131C69.6411 57.6131 70.3965 57.7964 71.063 58.163C71.7296 58.5295 72.2572 59.035 72.646 59.6793C73.0348 60.3125 73.2292 61.029 73.2292 61.8288C73.2292 62.6286 73.0348 63.3507 72.646 63.995C72.2572 64.6393 71.7296 65.1503 71.063 65.5279C70.3965 65.8945 69.6411 66.0778 68.7969 66.0778ZM68.7969 63.7617C69.1635 63.7617 69.4856 63.6839 69.7633 63.5284C70.041 63.3618 70.2521 63.1341 70.3965 62.8452C70.552 62.5453 70.6298 62.2065 70.6298 61.8288C70.6298 61.4511 70.552 61.1234 70.3965 60.8457C70.241 60.5569 70.0244 60.3347 69.7467 60.1792C69.4801 60.0125 69.1635 59.9292 68.7969 59.9292C68.4414 59.9292 68.1248 60.0125 67.8471 60.1792C67.5694 60.3347 67.3528 60.5569 67.1973 60.8457C67.0417 61.1345 66.964 61.4678 66.964 61.8455C66.964 62.212 67.0417 62.5453 67.1973 62.8452C67.3528 63.1341 67.5694 63.3618 67.8471 63.5284C68.1248 63.6839 68.4414 63.7617 68.7969 63.7617ZM74.4985 65.8945V53.7973H77.0479V65.8945H74.4985ZM82.2924 66.0612C81.5259 66.0612 80.8427 65.8779 80.2428 65.5113C79.6541 65.1447 79.1875 64.6448 78.8432 64.0116C78.5099 63.3784 78.3433 62.6564 78.3433 61.8455C78.3433 61.0345 78.5099 60.3125 78.8432 59.6793C79.1875 59.0461 79.6541 58.5462 80.2428 58.1796C80.8427 57.813 81.5259 57.6298 82.2924 57.6298C82.8478 57.6298 83.3477 57.7353 83.792 57.9463C84.2475 58.1574 84.6196 58.4518 84.9084 58.8295C85.2084 59.1961 85.375 59.6182 85.4083 60.0959V63.5117C85.375 63.9894 85.2139 64.4226 84.9251 64.8114C84.6363 65.1891 84.2641 65.4946 83.8087 65.7279C83.3532 65.9501 82.8478 66.0612 82.2924 66.0612ZM82.7423 63.7617C83.1089 63.7617 83.4254 63.6839 83.6921 63.5284C83.9587 63.3618 84.1697 63.1341 84.3252 62.8452C84.4808 62.5564 84.5585 62.2231 84.5585 61.8455C84.5585 61.4678 84.4808 61.1401 84.3252 60.8623C84.1808 60.5735 83.9698 60.3458 83.6921 60.1792C83.4254 60.0125 83.1144 59.9292 82.7589 59.9292C82.4035 59.9292 82.0869 60.0125 81.8091 60.1792C81.5425 60.3458 81.3259 60.5735 81.1593 60.8623C81.0038 61.1512 80.926 61.4789 80.926 61.8455C80.926 62.212 81.0038 62.5397 81.1593 62.8286C81.3148 63.1174 81.5314 63.3451 81.8091 63.5117C82.0869 63.6784 82.3979 63.7617 82.7423 63.7617ZM86.958 65.8945H84.4585V63.7117L84.8418 61.7455L84.4086 59.7793V53.7973H86.958V65.8945ZM92.1594 65.8945V54.1306H94.0256L98.6579 61.3456H97.7081L102.324 54.1306H104.207V65.8945H101.591V58.5462L102.057 58.6629L99.0411 63.3618H97.3082L94.3089 58.6629L94.7588 58.5462V65.8945H92.1594ZM110.229 66.0778C109.351 66.0778 108.568 65.9001 107.879 65.5446C107.201 65.178 106.668 64.6726 106.279 64.0283C105.891 63.384 105.696 62.6564 105.696 61.8455C105.696 61.0345 105.885 60.3125 106.263 59.6793C106.652 59.035 107.174 58.5295 107.829 58.163C108.485 57.7964 109.223 57.6131 110.045 57.6131C110.845 57.6131 111.55 57.7853 112.161 58.1296C112.772 58.474 113.25 58.9517 113.594 59.5626C113.95 60.1736 114.128 60.8735 114.128 61.6622C114.128 61.8066 114.117 61.9621 114.094 62.1287C114.083 62.2842 114.055 62.4675 114.011 62.6786L107.029 62.6953V60.9457L112.928 60.929L111.828 61.6622C111.817 61.1956 111.745 60.8124 111.612 60.5124C111.478 60.2014 111.278 59.9681 111.012 59.8126C110.756 59.646 110.44 59.5626 110.062 59.5626C109.662 59.5626 109.312 59.6571 109.012 59.8459C108.723 60.0237 108.496 60.2791 108.329 60.6124C108.173 60.9457 108.096 61.3511 108.096 61.8288C108.096 62.3065 108.179 62.7175 108.346 63.0618C108.523 63.3951 108.768 63.6562 109.079 63.845C109.401 64.0227 109.779 64.1116 110.212 64.1116C110.612 64.1116 110.973 64.045 111.295 63.9117C111.617 63.7672 111.9 63.5562 112.145 63.2785L113.544 64.6781C113.145 65.1447 112.661 65.4946 112.095 65.7279C111.528 65.9612 110.906 66.0778 110.229 66.0778ZM115.358 65.8945V57.7964H117.908V65.8945H115.358ZM120.54 65.8945V61.1623C120.54 60.7513 120.413 60.4347 120.157 60.2125C119.913 59.9792 119.607 59.8626 119.241 59.8626C118.985 59.8626 118.757 59.9181 118.558 60.0292C118.358 60.1292 118.196 60.2736 118.074 60.4624C117.963 60.6513 117.908 60.8846 117.908 61.1623L116.925 60.729C116.925 60.0847 117.063 59.5349 117.341 59.0794C117.619 58.6129 117.997 58.2574 118.474 58.013C118.952 57.7575 119.491 57.6298 120.091 57.6298C120.657 57.6298 121.162 57.7575 121.607 58.013C122.062 58.2685 122.423 58.624 122.69 59.0794C122.957 59.5349 123.09 60.0792 123.09 60.7124V65.8945H120.54ZM125.723 65.8945V61.1623C125.723 60.7513 125.595 60.4347 125.339 60.2125C125.095 59.9792 124.789 59.8626 124.423 59.8626C124.167 59.8626 123.94 59.9181 123.74 60.0292C123.54 60.1292 123.379 60.2736 123.256 60.4624C123.145 60.6513 123.09 60.8846 123.09 61.1623L121.623 60.9623C121.646 60.2736 121.807 59.6848 122.107 59.1961C122.418 58.6962 122.823 58.3129 123.323 58.0463C123.834 57.7686 124.406 57.6298 125.039 57.6298C125.661 57.6298 126.211 57.7631 126.689 58.0297C127.178 58.2852 127.561 58.6573 127.839 59.1461C128.128 59.6237 128.272 60.2014 128.272 60.879V65.8945H125.723ZM134.571 66.0612C134.027 66.0612 133.527 65.9501 133.072 65.7279C132.616 65.4946 132.244 65.1891 131.955 64.8114C131.666 64.4226 131.5 63.9894 131.455 63.5117V60.0959C131.5 59.6182 131.666 59.1961 131.955 58.8295C132.244 58.4518 132.616 58.1574 133.072 57.9463C133.527 57.7353 134.027 57.6298 134.571 57.6298C135.338 57.6298 136.015 57.813 136.604 58.1796C137.204 58.5462 137.671 59.0461 138.004 59.6793C138.348 60.3125 138.52 61.0345 138.52 61.8455C138.52 62.6564 138.348 63.3784 138.004 64.0116C137.671 64.6448 137.204 65.1447 136.604 65.5113C136.015 65.8779 135.338 66.0612 134.571 66.0612ZM134.121 63.7617C134.477 63.7617 134.788 63.6784 135.055 63.5117C135.332 63.3451 135.549 63.1174 135.704 62.8286C135.86 62.5397 135.938 62.212 135.938 61.8455C135.938 61.4678 135.86 61.1345 135.704 60.8457C135.549 60.5569 135.332 60.3347 135.055 60.1792C134.788 60.0125 134.477 59.9292 134.121 59.9292C133.766 59.9292 133.449 60.0125 133.172 60.1792C132.894 60.3347 132.677 60.5569 132.522 60.8457C132.377 61.1345 132.305 61.4678 132.305 61.8455C132.305 62.2231 132.383 62.5564 132.538 62.8452C132.694 63.1341 132.905 63.3618 133.172 63.5284C133.449 63.6839 133.766 63.7617 134.121 63.7617ZM129.906 65.8945V53.7973H132.455V59.7793L132.039 61.7455L132.422 63.7117V65.8945H129.906ZM143.815 66.0778C142.937 66.0778 142.154 65.9001 141.465 65.5446C140.788 65.178 140.254 64.6726 139.866 64.0283C139.477 63.384 139.282 62.6564 139.282 61.8455C139.282 61.0345 139.471 60.3125 139.849 59.6793C140.238 59.035 140.76 58.5295 141.415 58.163C142.071 57.7964 142.809 57.6131 143.631 57.6131C144.431 57.6131 145.137 57.7853 145.748 58.1296C146.358 58.474 146.836 58.9517 147.181 59.5626C147.536 60.1736 147.714 60.8735 147.714 61.6622C147.714 61.8066 147.703 61.9621 147.68 62.1287C147.669 62.2842 147.642 62.4675 147.597 62.6786L140.615 62.6953V60.9457L146.514 60.929L145.414 61.6622C145.403 61.1956 145.331 60.8124 145.198 60.5124C145.064 60.2014 144.864 59.9681 144.598 59.8126C144.342 59.646 144.026 59.5626 143.648 59.5626C143.248 59.5626 142.898 59.6571 142.598 59.8459C142.309 60.0237 142.082 60.2791 141.915 60.6124C141.76 60.9457 141.682 61.3511 141.682 61.8288C141.682 62.3065 141.765 62.7175 141.932 63.0618C142.109 63.3951 142.354 63.6562 142.665 63.845C142.987 64.0227 143.365 64.1116 143.798 64.1116C144.198 64.1116 144.559 64.045 144.881 63.9117C145.203 63.7672 145.486 63.5562 145.731 63.2785L147.131 64.6781C146.731 65.1447 146.247 65.4946 145.681 65.7279C145.114 65.9612 144.492 66.0778 143.815 66.0778ZM148.944 65.8945V57.7964H151.494V65.8945H148.944ZM151.494 61.4455L150.427 60.6124C150.638 59.6682 150.994 58.935 151.494 58.4129C151.994 57.8908 152.688 57.6298 153.577 57.6298C153.965 57.6298 154.304 57.6909 154.593 57.813C154.893 57.9241 155.154 58.1019 155.376 58.3463L153.86 60.2625C153.749 60.1403 153.61 60.0459 153.443 59.9792C153.277 59.9126 153.088 59.8792 152.877 59.8792C152.455 59.8792 152.116 60.0125 151.86 60.2791C151.616 60.5346 151.494 60.9234 151.494 61.4455Z",
    fill: "#2C2C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_374_96116",
    x: 274.534,
    y: 34.6593,
    width: 23.8025,
    height: 15.5759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925714,
    result: "effect1_foregroundBlur_374_96116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_374_96116",
    x: 261.692,
    y: 40.5593,
    width: 33.8629,
    height: 53.6393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.62857,
    result: "effect1_foregroundBlur_374_96116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_374_96116",
    x: 206.524,
    y: -23.0006,
    width: 175.527,
    height: 90.4191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.43584,
    result: "effect1_foregroundBlur_374_96116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dddddd_374_96116",
    x: -51.8396,
    y: 23.7547,
    width: 163.851,
    height: 163.851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28084
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973442
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.037943 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.33932
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0479222 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_374_96116",
    result: "effect2_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40472
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0544001 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_374_96116",
    result: "effect3_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.85728
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0602938 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_374_96116",
    result: "effect4_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.3371
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6962
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0681504 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_374_96116",
    result: "effect5_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 46.2857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.1771
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_374_96116",
    result: "effect6_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_374_96116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dddddd_374_96116",
    x: -11.8801,
    y: 52.8262,
    width: 83.6226,
    height: 95.8338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28084
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.512338
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.0787208 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23122
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.11309 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_374_96116",
    result: "effect2_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.31828
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_374_96116",
    result: "effect3_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.13541
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.16691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_374_96116",
    result: "effect4_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.3371
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.73483
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.201279 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_374_96116",
    result: "effect5_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 46.2857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.5143
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_374_96116",
    result: "effect6_dropShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_374_96116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_374_96116",
    x: 25.1484,
    y: 52.7086,
    width: 9.25684,
    height: 12.1521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.132245
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117551
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_374_96116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.117551
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.36
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_374_96116",
    result: "effect2_innerShadow_374_96116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_374_96116",
    x: 27.1915,
    y: 52.2335,
    width: 3.18723,
    height: 7.13547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.293878
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_374_96116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_374_96116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_374_96116",
    x: 27.412,
    y: 52.4735,
    width: 4.72386,
    height: 6.60472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.176327,
    result: "effect1_foregroundBlur_374_96116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_374_96116",
    x: 28.7851,
    y: 52.1649,
    width: 1.98358,
    height: 2.216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.330612,
    result: "effect1_foregroundBlur_374_96116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_374_96116",
    x1: 255.723,
    y1: 31.5201,
    x2: 207.49,
    y2: 202.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_374_96116",
    x1: 364.652,
    y1: 15.8192,
    x2: 254.279,
    y2: 139.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0550575,
    stopColor: "#F2E158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170676,
    stopColor: "#FCF5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309086,
    stopColor: "#ECD42F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491314,
    stopColor: "#E9B00C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704021,
    stopColor: "#ECB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78935,
    stopColor: "#E8CF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843399,
    stopColor: "#EBD431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909367,
    stopColor: "#E2C317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D14F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_374_96116",
    x1: 362.756,
    y1: 16.627,
    x2: 240.737,
    y2: 139.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEBB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0550575,
    stopColor: "#FDEE48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170676,
    stopColor: "#E8BB06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309086,
    stopColor: "#D57B01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491314,
    stopColor: "#C86101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660555,
    stopColor: "#D88C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771761,
    stopColor: "#E8BE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815114,
    stopColor: "#E8BE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881945,
    stopColor: "#E8AE0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930202,
    stopColor: "#D98317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBAE4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_374_96116",
    x1: 354.303,
    y1: 0.336062,
    x2: 241.787,
    y2: 128.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0550575,
    stopColor: "#F2E158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170676,
    stopColor: "#FCF5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309086,
    stopColor: "#ECD42F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491314,
    stopColor: "#E9B00C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704021,
    stopColor: "#ECB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78935,
    stopColor: "#E8CF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843399,
    stopColor: "#EBD431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909367,
    stopColor: "#E2C317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D14F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_374_96116",
    x1: 318.477,
    y1: -20.9744,
    x2: 263.751,
    y2: 125.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417119,
    stopColor: "#FFED97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF27B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_374_96116",
    x1: 259.654,
    y1: 11.132,
    x2: 318.57,
    y2: 89.1705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4991A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474971,
    stopColor: "#EAAA2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF27B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_374_96116",
    x1: 28.8016,
    y1: 53.904,
    x2: 25.7888,
    y2: 58.2664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_374_96116",
    x1: 30.9252,
    y1: 53.904,
    x2: 27.7773,
    y2: 57.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_374_96116",
    x1: 33.4305,
    y1: 53.904,
    x2: 30.4177,
    y2: 58.2664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_374_96116",
    x1: 28.8016,
    y1: 59.8552,
    x2: 25.7888,
    y2: 64.2176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_374_96116",
    x1: 30.9252,
    y1: 59.8552,
    x2: 27.7773,
    y2: 63.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_374_96116",
    x1: 33.4305,
    y1: 59.8552,
    x2: 30.4177,
    y2: 64.2176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_374_96116",
    x1: 34.4056,
    y1: 52.8262,
    x2: 22.3105,
    y2: 57.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_374_96116",
    x1: 25.1484,
    y1: 52.8262,
    x2: 37.2436,
    y2: 57.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_374_96116",
    x1: 29.777,
    y1: 52.8262,
    x2: 29.777,
    y2: 64.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_374_96116",
    x1: 25.1484,
    y1: 52.8262,
    x2: 33.9792,
    y2: 65.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_374_96116",
    x1: 34.4056,
    y1: 52.8262,
    x2: 25.5748,
    y2: 65.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_374_96116",
    x1: 29.777,
    y1: 58.7772,
    x2: 29.0351,
    y2: 64.6342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_374_96116",
    x1: 29.7769,
    y1: 52.8259,
    x2: 27.7932,
    y2: 58.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EE7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_374_96116",
    x1: 31.3504,
    y1: 59.852,
    x2: 28.4434,
    y2: 61.6784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_374_96116",
    x1: 29.7769,
    y1: 52.8262,
    x2: 29.7769,
    y2: 53.7199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_96116"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_374_96116"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5146,
    y: 47.8232,
    width: 23.1429,
    height: 23.1429,
    rx: 11.5714,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_374_96116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.25714,
    height: 11.902,
    fill: "white",
    transform: "translate(25.1484 52.8262)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_374_96116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.01878,
    height: 5.89959,
    fill: "white",
    transform: "translate(27.7646 52.8262)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberGold);
export default __webpack_public_path__ + "static/media/member_gold.7eb87505c0462fae34f70db22d8b5058.svg";
export { ForwardRef as ReactComponent };